export const UNAPPLIED_STUDENTS_REPORT_LOADING =
  'UNAPPLIED_STUDENTS_REPORT_LOADING';
export const UNAPPLIED_STUDENTS_REPORT_LOAD_ERROR =
  'UNAPPLIED_STUDENTS_REPORT_LOAD_ERROR';
export const UNAPPLIED_STUDENTS_REPORT_GET_REPORT =
  'UNAPPLIED_STUDENTS_REPORT_GET_REPORT';
export const UNAPPLIED_STUDENTS_REPORT_SET_SELECTED_SITES =
  'UNAPPLIED_STUDENTS_REPORT_SET_SITES';
export const UNAPPLIED_STUDENTS_REPORT_CLEAR_ERRORS =
  'UNAPPLIED_STUDENTS_REPORT_CLEAR_ERRORS';
export const UNAPPLIED_STUDENTS_REPORT_GET_GRADES =
  'UNAPPLIED_STUDENTS_REPORT_GET_GRADES';



// WEBPACK FOOTER //
// ./src/pages/unappliedstudents/state/report/types.js